

export const PRIMARY_CUSTOMER_SERVICE = 'online@diamondsdirect.com';


// WEBPACK FOOTER //
// ./src/constants/contacts.jsx